import React from 'react';
import { ITeamCardsContent } from '../TeemPersonCard/teemPersonData';

import LinkedInIcon from '@mui/icons-material/LinkedIn';

import GitHubIcon from '@mui/icons-material/GitHub';
import SummarizeOutlinedIcon from '@mui/icons-material/SummarizeOutlined';

import '../TeemCard.css';

interface IProps {
    personContent: ITeamCardsContent;
}

export const TeemPersonCard: React.FC<IProps> = ({ personContent }) => {
    const {
        avatarImg,
        name,
        profession,
        linkedIn,
        summary,
        git, } = personContent

    return (
        <>
            <div className="teemCard__person-thamb">
                <div className='teemCard__img-wrapper'>
                    <img className='teemCard__img-person' src={avatarImg} alt="" />
                </div>
            </div>
            {/* описание учасника имя и профессия */}
            <div className='teemCard__description-person'>
                <p className='teemCard__name-person'>{name}</p>
                <p className='teemCard__person-major'>{profession}</p>

                {/* соцсети учасника */}
                <ul className='teemCard__icon-list'>
                    <li className='teemCard__icon-item'><a href={summary} target="_blank" aria-label="Summary" title='Summary'> <SummarizeOutlinedIcon /> </a></li>
                    <li className='teemCard__icon-item' ><a href={linkedIn} target="_blank" aria-label="LinkedIn" title='LinkedIn'> <LinkedInIcon /></a></li>
                    <li className='teemCard__icon-item'><a href={git} target="_blank" aria-label="GitHub Page" title='GitHub Page'><GitHubIcon /></a></li>
                </ul>
            </div>
        </>
    )
}
